import { useProductEditor } from '../product-editor-context'
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { Plus, Trash2, List } from 'lucide-react'

export function KeyFeaturesSection() {
  const {
    keyFeatures,
    addFeature,
    removeFeature,
    updateFeature,
  } = useProductEditor()

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <List className="size-5 text-zinc-500" />
            <div>
              <CardTitle className="text-base">Key Features</CardTitle>
              <CardDescription>
                Bullet points shown on product page ({keyFeatures.filter(f => f).length} added)
              </CardDescription>
            </div>
          </div>
          <Button type="button" variant="outline" size="sm" onClick={addFeature}>
            <Plus className="mr-1 size-3" /> Add Feature
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {keyFeatures.map((feature, i) => (
            <div key={i} className="flex gap-2">
              <Input
                value={feature}
                onChange={(e) => updateFeature(i, e.target.value)}
                placeholder="e.g., 4K Resolution, 10hr Battery Life"
                className="flex-1"
              />
              <Button
                type="button"
                variant="ghost"
                size="icon"
                onClick={() => removeFeature(i)}
                className="text-red-500 hover:text-red-600 hover:bg-red-50"
              >
                <Trash2 className="size-4" />
              </Button>
            </div>
          ))}
          {keyFeatures.length === 0 && (
            <p className="text-sm text-zinc-400 text-center py-4">
              No features added yet. Click "Add Feature" to start.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
